import "core-js/modules/es.symbol";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.for-each";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useLanguage } from './useLanguage';
export var useLocalizedHistory = function useLocalizedHistory() {
  var history = useHistory();

  var _useLanguage = useLanguage(),
      toLocalizedRoute = _useLanguage.toLocalizedRoute;

  var localizedHistoryPush = useCallback(function (path, state) {
    if (typeof path === 'string') {
      history.push(toLocalizedRoute(path), state);
    } else {
      history.push(_objectSpread({}, path, {
        pathname: path.pathname ? toLocalizedRoute(path.pathname) : path.pathname
      }), state);
    }
  }, [history.push, toLocalizedRoute]);
  var localizedHistoryReplace = useCallback(function (path, state) {
    if (typeof path === 'string') {
      history.replace(toLocalizedRoute(path), state);
    } else {
      history.replace(_objectSpread({}, path, {
        pathname: path.pathname ? toLocalizedRoute(path.pathname) : path.pathname
      }), state);
    }
  }, [history.replace, toLocalizedRoute]);
  return _objectSpread({}, history, {
    push: localizedHistoryPush,
    replace: localizedHistoryReplace
  });
};